import { render } from "./PayPalCardPurchase.vue?vue&type=template&id=8370e032"
import script from "./PayPalCardPurchase.vue?vue&type=script&lang=js"
export * from "./PayPalCardPurchase.vue?vue&type=script&lang=js"

import "./PayPalCardPurchase.vue?vue&type=style&index=0&id=8370e032&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__